<template>
  <div>
    <div class="form-group row">
      <label v-if="nolabel !== true" :class="nolabel ? '' : 'col-sm-' + labelCol" class="col-form-label">{{ title || '&nbsp;' }}</label>
      <div class="col-form-input input-group" :class="nolabel ? 'col-sm-12' : 'col-sm-' + (12 - labelCol)">
        <input ref="input" v-model="inputText" type="text" :placeholder="placeholder" class="form-control" :required="required ? true : false" :readonly="true" />
        <div v-if="readonly !== true" class="input-group-append">
          <button class="btn btn-outline-secondary" @click="popChooseUser" type="button">Choose WorkFlow Action</button>
        </div>
      </div>
      <label v-if="isValid === false" id="basic-error" class="validation-invalid-label" for="basic">{{ $helper.getWord('ui.SYS00016') }}</label>
    </div>
    <div ref="modal" class="modal fade" tabindex="-1" aria-hidden="true" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-full">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" aria-label="Close" @click="closePicker">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <WfPicker :id="id + '_userpicker'" ref="userpicker" :multiple="true" v-model="val" :titleText="header" @applyRecord="applyRecord" :includeSelf="includeSelf" :excludeUsers="excludeUsers" :delayLoad="delayLoad" :includeUsers="includeUsers" :defaultSelect="defaultSelect"  :inDialog="true" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-link legitRipple" @click="closePicker"><i class="icon-cross2 font-size-base mr-1"></i>{{ $helper.getWord('Close') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import WfPicker from '@/components/wfpicker'
import helper from "@/vueHelper"

export default {
  name: 'WfActionSelect',
  components: { WfPicker },
  props: ['id', 'title', 'placeholder', 'titleText', 'value', 'readonly', 'required', 'delegate_fullname', 'labelwidth', 'nolabel', 'includeSelf', 'excludeUsers', 'delayLoad','includeUsers','defaultSelect'],
  data () {
    return {
      isValid: true,
      val: this.value,
      display: null,
      header:this.titleText||"Choose WorkFlow Action",
      inputText:null
    }
  },
  mounted () {
    this.setValue(this.value);

    if (this.format) {
      var f = this.format.split(',')
      if (f.length > 0) this.digit = f[0]
      if (f.length > 1) this.decimal = f[1]
    }

    $(this.$refs.modal).on('shown.bs.modal', $.proxy(function () {
      $.each(this.$refs.userpicker.$children, function (i, c) {
        if (c.initSelect2) {
          c.initSelect2()
        }
        if (c.initPickadate) {
          c.initPickadate()
        }
        if (c.initRadio) {
          c.initRadio()
        }
      })
    }, this))
  },
  methods: {
    setValue(val){
       if (val&&Array.isArray(val)) {
        let map = val.map(o=>o.name);
        this.inputText = helper.joinVal(map);
      } else {
        this.inputText = null
      }
      this.val = val
    },
    setFocus () {
      this.$refs.input.focus()
    },
    setValid (val) {
      this.isValid = val
    },
    isFieldValid () {
      return !this.required || (this.required && this.val !== null && this.val !== undefined && this.val !== '')
    },
    dataChanged (e) {
      this.$emit('input', this.val, this)
    },
    resetValue () {
      this.isValid = true
      this.val = null
      this.inputText = null
    },
    popChooseUser () {
      $(this.$refs.modal).modal('show')
    },
    applyRecord (records) {
      if (records.length > 0) {
        let map = records.map(o=>o.name);
        this.val = records;
        this.inputText = helper.joinVal(map);
        this.$emit('input', this.val, this)
      }else{
        this.val = records;
        this.$emit('input', this.val, this)
      }
      $(this.$refs.modal).modal('hide')
    },
    closePicker () {
      $(this.$refs.modal).modal('hide')
    }
  },
  computed: {
    labelCol () {
      return this.labelwidth || 3
    }
  },
  watch: {
    value: function (val) {  
      this.setValue(val);
      this.setValid(this.isFieldValid())
    },
  }
}
</script>
<style>
.modal-content {
  background: #eee;
}
.modal-full{max-width:94%;margin-left:3%;margin-right:3%}
</style>
